export function TikTokBorder(props) {
  return (
    <svg
      width="374"
      height="14"
      preserveAspectRatio="none"
      viewBox="0 0 374 14"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-773 14H-772.157H1147V3L1045.98 4.89439L958.581 3.28634L838.801 7.79412L718.531 4.89439L646.32 7.79412L580.173 3.28677L438.836 4.89439L297.509 7.00224L177.891 1.70454C177.891 1.70454 120.289 5.58296 94.84 5.58296C69.3905 5.58296 56.44 1.70454 36.6226 1.70454C16.8051 1.70454 -94.3619 8.52116 -94.3619 8.52116L-218.125 7.00224H-334.139L-558.372 0L-691.846 4.89439L-773 3V14Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
